/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authresolvefailedtitle3Inputs */



/**
* | output |
* | --- |
* | "Unable to login" |
*
* @param {Authresolvefailedtitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const authresolvefailedtitle3 = /** @type {((inputs?: Authresolvefailedtitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authresolvefailedtitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unable to login")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo iniciar sesión")
	return /** @type {LocalizedString} */ ("Не удалось войти")
});
export { authresolvefailedtitle3 as "authResolveFailedTitle" }